// extracted by mini-css-extract-plugin
module.exports = {"container":"games_container__2S1bP","Gallery":"games_Gallery__dWEkD","GalleryCard1":"games_GalleryCard1__2K0Km","GalleryCard2":"games_GalleryCard2__2-PuP"};